import * as React from 'react'

const RightSidebar = () => {
	return (
		<>
			<div className="col-md-6 col-sm-6 col-xs-12 col-size">
				<div className="news-container mt-40">
					<iframe
						src="https://app.readpeak.com/ads/get/?l=579f889b0cd477a5"
						id="mcn_iframe_579f889b0cd477a5-1"
						style={{ width: '100%', maxWidth: '600px', height: '350px', border: 'none' }}
					></iframe>
				</div>
			</div>
		</>
	)
}
export default RightSidebar
